const LINEAR_PREFIX = "linear-gradient(";
const RADIAL_PREFIX = "radial-gradient(";

export const isLinearGradient = (value: string | undefined): boolean => {
	if (typeof value !== "string" || value.length === 0) return false;
	return value.trimStart().startsWith(LINEAR_PREFIX);
};

export const isRadialGradient = (value: string | undefined): boolean => {
	if (typeof value !== "string" || value.length === 0) return false;
	return value.trimStart().startsWith(RADIAL_PREFIX);
};

export const isGradient = (value: string | undefined): boolean => {
	return isLinearGradient(value) || isRadialGradient(value);
};
